export default __webpack_public_path__ + "static/media/AQ.13e48135.ico";